import { z } from 'zod';

export const WarrantyPenaltyPredictionSchema = z.object({
  appliesAt: z.date(),
  penaltyDelta: z.number(),
});

export type WarrantyPenaltyPrediction = z.infer<
  typeof WarrantyPenaltyPredictionSchema
>;

export const WarrantyPenaltyCurrentSchema = z.object({
  lastDetectedAt: z.date().optional(),
  penalty: z.number(),
  extremeValue: z.number(),
  extremeValueUnit: z.string(), // Unit (%, C, MWh) of extremeValue
  durationHours: z.number().optional(),
  count: z.number().optional(),
});

export type WarrantyPenaltyCurrent = z.infer<
  typeof WarrantyPenaltyCurrentSchema
>;

export const WarrantyPenaltySchema = z.object({
  id: z.string(),
  description: z.string(),
  current: WarrantyPenaltyCurrentSchema.optional(),
  prediction: WarrantyPenaltyPredictionSchema.optional(),
});

export type WarrantyPenalty = z.infer<typeof WarrantyPenaltySchema>;
